__turbopack_context__.v({
  "container": "cart-module__-RJi4G__container",
  "content": "cart-module__-RJi4G__content",
  "itemCount": "cart-module__-RJi4G__itemCount",
  "leftSection": "cart-module__-RJi4G__leftSection",
  "rightSection": "cart-module__-RJi4G__rightSection",
  "title": "cart-module__-RJi4G__title",
});
